import React from 'react';
import withWrapper from '../withWrapper';
export default withWrapper('SwitchOn', function (props) {
  return React.createElement("svg", {
    width: "12",
    height: "12",
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8999 3.31959C10.1928 3.61248 10.1928 4.08736 9.8999 4.38025L5.68023 8.66058C5.38734 8.95347 4.91247 8.95347 4.61957 8.66058L2.11957 6.16058C1.82668 5.86769 1.82668 5.39281 2.11957 5.09992C2.41247 4.80703 2.88734 4.80703 3.18023 5.09992L5.1499 7.06959L8.83924 3.31959C9.13214 3.0267 9.60701 3.0267 9.8999 3.31959Z",
    fill: props.outStrokeColor
  }));
});